/* ============================================================
   FRUMMYS · theme.js
   ============================================================ */
(function(){
  /* --- Menú móvil --- */
  var btn = document.querySelector('.nav-toggle');
  var panel = document.getElementById('mobile-menu');
  if(btn && panel){
    function open(){ document.body.classList.add('menu-open'); btn.setAttribute('aria-expanded','true'); }
    function close(){ document.body.classList.remove('menu-open'); btn.setAttribute('aria-expanded','false'); }
    function toggle(){ document.body.classList.contains('menu-open') ? close() : open(); }
    btn.addEventListener('click', toggle);
    panel.addEventListener('click', function(e){ if(e.target.closest('a')) close(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
    var mq = window.matchMedia('(min-width:981px)');
    var onMq = function(e){ if(e.matches) close(); };
    if(mq.addEventListener){ mq.addEventListener('change', onMq); }
    else if(mq.addListener){ mq.addListener(onMq); }
  }
})();
